import { t } from "../../../hooks/useAppTranslation";
import {useState} from 'react';

import {addDocument} from '../../../Properties/Properties';
import {getServicePromise} from '../../HttpService/HttpService';
import PopUp from '../../PopUp/PopUp';
import {FilePreview} from '..';


export const ExistingInControlFile = ({
                                        controlUuid, duplicatedFile, fileId, onCancel, onError, onSuccess, saveAsDraft
                                      }) => {
  /*
    This component should be used when one adds file to document and it turns
    out there is the same file joined to the control. Then, one needs to choose
    between adding the new one and using the existing one
  */
  const [documentData, setDocumentData] = useState(null);
  const [joinToDocument, setJoinToDocument] = useState(null);
  const [savingOn, setSavingOn] = useState(false);
  const [fetchError, setFetchError] = useState(null);

  function handleSave(ev, joinToDocument=false) {
    setJoinToDocument(joinToDocument);
    setSavingOn(true);
    const callPromise = getServicePromise(
       addDocument(controlUuid,saveAsDraft),
      'POST',
      {fileId: joinToDocument ? duplicatedFile.id : fileId, forced: true}
    );
    callPromise.then(
      function (data) {
        // original data from server, with the structure:
        // {changedDocument: {}/null, duplicatedDocument: {}/null}
        setDocumentData(data);
        setSavingOn(false);
      },
      function (error) {
        setFetchError(error);
        setSavingOn(false);
      }
    );
  }

  if (fetchError !== null) {
    // there was an error when one tried to send request to backend;
    // it was impossible to join filet o document or create the new one
    return (
      <PopUp
        notification={fetchError}
        title={t('g-notification')}
        type="error"
        closePopUp={onError}
        onClickEvent={onError}
      />
    )
  }

  if (!savingOn && joinToDocument !== null) {
    return (
      <PopUp
        notification={
          joinToDocument
            ? t('g-file-located-manage-documents')
            : t('g-new-document-added')
        }
        title={t('g-notification')}
        closePopUp={() => onSuccess(documentData)}
      />
    )
  }

  return (
    <PopUp
      customContent
      title={t('g-notification')}
      handleClosePopup={savingOn ? () => {} : onCancel}
    >
      <div className="col-12">
        <p role="status">{ t('g-document-in-manage-documents-link') }</p>
        <div className="row">
          <div className="col-8">
            <FilePreview buttonDisabled={savingOn} fileData={duplicatedFile} />
          </div>
          <div className="col-4 documents__btn-container">
            <button
              className="btn cancel-btn mr-2"
              disabled={savingOn}
              type="button"
              onClick={handleSave}
            >
              { t('g-no') }<span className="sr-only"> { t('g-link-to-document') }</span>
            </button>
            <button
                className="btn save-btn"
                disabled={savingOn}
                type="button"
                onClick={ev => handleSave(ev, true)}
            >
              { t('g-yes') }<span className="sr-only">, { t('g-link-document') }</span>
            </button>
          </div>
        </div>
      </div>
    </PopUp>
  )
};
